'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeFitnessLeaderboard = exports.fetchFitnessLeaderboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _pages = require('../../pages');

var _client = require('../../../utils/client');

var client = _interopRequireWildcard(_client);

var _params = require('../../../utils/params');

var _justgiving = require('../../../utils/justgiving');

var _leaderboards = require('../../../utils/leaderboards');

var _totals = require('../../../utils/totals');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchActivePages = function fetchActivePages(pages) {
  var pageGuids = pages.map(function (page) {
    return page.ID;
  }).filter(Boolean);

  if (!pageGuids.length) {
    return pages;
  }

  return (0, _pages.fetchPages)({ ids: pageGuids, allPages: true }).then(function (results) {
    return results.map(function (page) {
      return page.pageGuid;
    });
  }).then(function (activePageIds) {
    return pages.filter(function (page) {
      return activePageIds.indexOf(page.ID) > -1;
    });
  });
};

var fetchFitnessLeaderboard = exports.fetchFitnessLeaderboard = function fetchFitnessLeaderboard(_ref) {
  var _ref$campaign = _ref.campaign,
      campaign = _ref$campaign === undefined ? (0, _params.required)() : _ref$campaign,
      activeOnly = _ref.activeOnly,
      _ref$activityType = _ref.activityType,
      activityType = _ref$activityType === undefined ? 'any' : _ref$activityType,
      endDate = _ref.endDate,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 10 : _ref$limit,
      offset = _ref.offset,
      _ref$sortBy = _ref.sortBy,
      sortBy = _ref$sortBy === undefined ? 'distance' : _ref$sortBy,
      startDate = _ref.startDate,
      tagId = _ref.tagId,
      tagValue = _ref.tagValue,
      type = _ref.type,
      _ref$useLegacy = _ref.useLegacy,
      useLegacy = _ref$useLegacy === undefined ? true : _ref$useLegacy;

  if (tagId || tagValue) {
    return (0, _leaderboards.fetchLeaderboard)({
      activityType: activityType,
      id: (0, _params.getUID)(campaign),
      sortBy: sortBy,
      tagId: tagId,
      tagValue: tagValue,
      type: 'campaign'
    });
  }

  if (useLegacy || type === 'teams') {
    var params = {
      campaignGuid: campaign,
      limit: 200,
      offset: offset || 0,
      start: startDate,
      end: endDate
    };

    return client.get('/v1/fitness/campaign', params, {}, { paramsSerializer: _params.paramsSerializer }).then(function (result) {
      return type === 'team' ? result.teams : result.pages;
    }).then(function (items) {
      return items.slice(0, limit || 100);
    }).then(function (items) {
      return activeOnly && type !== 'team' ? fetchActivePages(items) : items;
    }).then(function (items) {
      return items.filter(function (item) {
        return item.Details;
      });
    }).then(function (items) {
      return items.map(function (item) {
        return _extends({}, item, { type: type || 'individual' });
      });
    });
  }

  return (0, _leaderboards.fetchLeaderboard)({
    activityType: activityType,
    id: (0, _params.getUID)(campaign),
    sortBy: sortBy,
    type: 'campaign'
  });
};

var deserializeFitnessLeaderboard = exports.deserializeFitnessLeaderboard = function deserializeFitnessLeaderboard(item, index) {
  var slug = (0, _get2.default)(item, 'Details.Url') || item.slug;

  return {
    charity: item.charity_name,
    distance: item.TotalValue || (0, _get2.default)(item, 'amounts[1].value', 0),
    id: item.ID || item.legacyId,
    image: (0, _get2.default)(item, 'heroMedia.url') ? (0, _get2.default)(item, 'heroMedia.url') + '?template=Size186x186Crop' : null || (0, _justgiving.imageUrl)((0, _get2.default)(item, 'Details.ImageId'), 'Size186x186Crop') || 'https://assets.blackbaud-sites.com/images/supporticon/user.svg',
    name: (0, _get2.default)(item, 'Details.Name') || item.title || item.tagValue,
    position: index + 1,
    raised: (0, _totals.getMonetaryValue)((0, _get2.default)(item, 'donationSummary.totalAmount')),
    slug: slug,
    status: item.status,
    subtitle: (0, _get2.default)(item, 'owner.name'),
    url: item.url || [(0, _justgiving.baseUrl)(), item.type === 'team' ? 'team' : 'fundraising', slug].join('/')
  };
};